import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

export default class tableDepositReportView extends JetView {
    // Defining a new class extending JetView
    config() {
        // Method to define the UI configuration
        const _ = this.app.getService('locale')._; // Localization service for translations
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        // Custom data filter for summing values in a tree column
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                refresh: function (master, node, value) {
                    // Refresh function for the filter
                    var result = 0; // Variable to hold the sum result
                    var resultFormat = 0; // Variable for formatted result
                    master.data.each(function (obj) {
                        // Iterating through master data
                        if (obj.$level == 1) result += obj[value.columnId]; // Summing values at level 1
                    });
                    // Formatting the result based on the column ID
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.intFormat(result);
                    } else {
                        resultFormat = webix.i18n.priceFormat(result);
                    }
                    node.firstChild.innerHTML = resultFormat; // Updating the node with formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Extending the existing summColumn filter
        );

        // Custom data filter for summing values in a column
        webix.ui.datafilter.mySummColumn = webix.extend(
            {
                refresh: function (master, node, value) {
                    // Refresh function for the filter
                    var result = 0; // Variable to hold the sum result
                    var resultFormat = 0; // Variable for formatted result
                    var size = $$('datatable').getPager().config.size; // Getting the page size
                    var page = $$('datatable').getPage(); // Getting the current page
                    var first = size * page; // Calculating the first item index
                    var last = first + size - 1; // Calculating the last item index
                    var count = 0; // Counter for items
                    master.data.each(function (obj) {
                        // Iterating through master data
                        if (count >= first && count <= last) {
                            // Checking if the item is in the current page
                            result += parseFloat(obj[value.columnId]); // Summing the value
                        }
                        count++; // Incrementing the counter
                    });
                    resultFormat = webix.i18n.priceFormat(result); // Formatting the result
                    node.firstChild.innerHTML = resultFormat; // Updating the node with formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Extending the existing summColumn filter
        );

        // Returning the UI configuration
        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader
                    cols: [
                        {
                            view: 'datatable', // Defining a datatable view
                            id: 'datatable', // ID for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                // Defining columns for the datatable
                                {
                                    id: 'detailTittle', // Column ID
                                    header: '', // Column header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    tooltip: _('Detalles'), // Tooltip for the column
                                    template: function (obj) {
                                        // Template function for rendering
                                        return "<span class='webix_icon wxi-close details'></span>"; // Returning HTML for the cell
                                    },
                                    footer: 'Total:', // Footer text for the column
                                },
                                {
                                    id: 'ActionTittle', // Column ID
                                    header: '', // Column header
                                    width: 70, // Column width
                                    height: 25, // Column height
                                    tooltip: 'Acción', // Tooltip for the column
                                    template: function (obj) {
                                        // Template function for rendering action icons in the datatable row
                                        let html = ''; // Variable to store generated HTML
                                        // Validation for showing "Pay" action icon based on permissions
                                        if (devConfig.getPermAction('depositRequestsPay', 'Pay')) {
                                            html += "<span title='Pagar' class='webix_icon wxi-close icon-tranfer prm-depositRequestsPay'></span>";
                                        }
                                        // Validation for showing "View Payment Receipt" icon
                                        if ((obj.PaymentDoc === true && obj.PaymentDoc !== undefined) &&
                                            devConfig.getPermAction('viewPaymentReceipt', 'Add')) {
                                            html += "<span title='Visualizar comprobante de pago' class='webix_icon wxi-file icon-file-text prm-viewPaymentReceipt'></span>";
                                        }
                                        return html; // Returning generated HTML for the cell
                                    },
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: 'ID', // Column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ClientId', // Column ID
                                    header: _('ID Usuario'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'FinalId', // Column ID
                                    header: _('ID Final'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'CreatedLocal', // Column ID
                                    header: _('Fecha de Creación'), // Column header with localization
                                    fillspace: 0, // Fill space option
                                    minWidth: 0, // Minimum width
                                    width: 150, // Column width
                                    sort: 'text', // Sorting type
                                    format: dateFormat, // Date formatting function
                                },
                                {
                                    id: 'Provider', // Column ID
                                    header: _('Proveedor'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'PaymentSystemName', // Column ID
                                    header: _('Nombre Sistema Pasarela Pago'), // Column header with localization
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'TypeName', // Column ID
                                    header: _('Tipo'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'CurrencyId', // Column ID
                                    header: _('Moneda'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Amount', // Column ID
                                    header: _('Valor'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Formatting function for prices
                                    exportType: 'number', // Export type
                                    footer: { content: 'mySummColumn' }, // Footer content using custom summation
                                    editor: 'text', // Editor type
                                },
                                {
                                    id: 'Tax', // Column ID
                                    header: _('Impuesto Deposito'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Formatting function for prices
                                    exportType: 'number', // Export type
                                    footer: { content: 'mySummColumn' }, // Footer content using custom summation
                                    editor: 'text', // Editor type
                                },
                                {
                                    id: 'ModifiedLocal', // Column ID
                                    header: _('Modificado'), // Column header with localization
                                    fillspace: 0, // Fill space option
                                    minWidth: 0, // Minimum width
                                    width: 150, // Column width
                                    sort: 'text', // Sorting type
                                    format: dateFormat, // Date formatting function
                                },
                                {
                                    id: 'State', // Column ID
                                    header: _('Estado'), // Column header with localization
                                    options: [
                                        // Options for the state column
                                        { id: '', value: _('None') },
                                        { id: 'A', value: _('Pagada') },
                                        { id: 'C', value: _('Cancelado') },
                                        { id: 'I', value: _('Inactivo') },
                                        { id: 'E', value: _('Enviada') },
                                        { id: 'EX', value: _('Expirada') },
                                        { id: 'R', value: _('Rechazada') },
                                        { id: 'P', value: _('Pendiente') },
                                    ],
                                },
                                {
                                    id: 'ExternalId', // Column ID
                                    header: _('External ID'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                    exportType: 'string', // Export type
                                },
                                {
                                    id: 'DigitalBankAccount', // Column ID
                                    header: _('Cuenta digital'), // Column header with localization
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Ip', // Column ID
                                    header: 'IP', // Column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ReasonRejection', // Column ID
                                    header: 'Motivo de Rechazo', // Column header
                                    width: 250, // Column width
                                    sort: 'string', // Sorting type
                                },
                            ],
                            onClick: {
                                // Event handlers for click events
                                details: function (euv, id) {
                                    // Handler for details icon click
                                    var item = this.getItem(id); // Getting the clicked item
                                    this.$scope.app.callEvent('deposit:id', [item.Id]); // Triggering an event with the item ID
                                    if (screen.width < 500 || screen.height < 500) {
                                        $$('filterDetails').show(); // Showing filter details for small screens
                                    } else {
                                        $$('dColl').expand(); // Expanding detail container
                                        $$('a5').scrollTo(0, 1000); // Scrolling to a specific position
                                    }
                                },
                                'icon-tranfer': function (euv, id) {
                                    // Handler for transfer icon click
                                    var vvthis = this; // Reference to the current context
                                    var item = vvthis.getItem(id); // Getting the clicked item
                                    var buttons = [
                                        // Defining buttons for the modal
                                        _('Aprobar Depósito'),
                                        _('Rechazar Depósito'),
                                        _('Cancelar'),
                                    ];
                                    if (item.State == 'A') {
                                        // Checking if the state is 'Approved'
                                        buttons = [
                                            // Adjusting buttons for approved state
                                            _('Rechazar Depósito'),
                                            _('Cancelar'),
                                        ];
                                        webix
                                            .modalbox({
                                                // Displaying a modal box
                                                id: 'modalAgent',
                                                title: _('¿ Qué desea realizar ?'), // Modal title
                                                buttons: buttons, // Modal buttons
                                                text: '', // Modal text
                                                width: screen.width < 500 ? 300 : 500, // Modal width
                                                height: screen.width < 500 ? 200 : 0, // Modal height
                                            })
                                            .then(function (result) {
                                                // Handling modal result
                                                var state; // Variable to hold the state
                                                switch (
                                                    result // Switch based on the result
                                                    ) {
                                                    case '0': // Approve action
                                                        state = '1'; // Setting state to 'Approved'
                                                        var tthis = this; // Reference to the current context
                                                        webix
                                                            .ajax() // Making an AJAX request
                                                            .headers({
                                                                'Content-type': 'application/json', // Setting content type
                                                            })
                                                            .post(
                                                                devConfig.geturlApi() + 'Financial/DepositRequests',
                                                                '{ "Id":' + item.Id + ', "State":"' + state + '"}', // Request body
                                                                {
                                                                    error: function (text, data, XmlHttpRequest) {
                                                                        // Error handler
                                                                        webix.message('Error! '); // Displaying error message
                                                                    },
                                                                    success: function (text, data, XmlHttpRequest) {
                                                                        // Success handler
                                                                        var data = JSON.parse(text); // Parsing response
                                                                        if (data.HasError) {
                                                                            // Checking for errors
                                                                            if (data.CodeError != 110012) {
                                                                                webix.message(
                                                                                    'No se proceso la solicitud. Comunicarse con soporte. ',
                                                                                ); // Displaying error message
                                                                            }
                                                                            tthis.getTopParentView().hide(); // Hiding the modal
                                                                        } else {
                                                                            item.State = 'R'; // Updating item state
                                                                            $$('datatable').refresh(); // Refreshing the datatable
                                                                            webix.message(
                                                                                'Se ha se procesado la solicitud satisfactoriamente. ',
                                                                            ); // Displaying success message
                                                                            tthis.getTopParentView().hide(); // Hiding the modal
                                                                        }
                                                                    },
                                                                },
                                                            );
                                                        break;
                                                    case '1': // Cancel action
                                                        this.getTopParentView().hide(); // Hiding the modal
                                                        break;
                                                }
                                            });
                                    } else {
                                        // If not approved
                                        webix
                                            .modalbox({
                                                // Displaying a modal box
                                                id: 'modalAgent',
                                                title: _('¿ Qué desea realizar ?'), // Modal title
                                                buttons: buttons, // Modal buttons
                                                text: '', // Modal text
                                                width: screen.width < 500 ? 300 : 500, // Modal width
                                                height: screen.width < 500 ? 200 : 0, // Modal height
                                            })
                                            .then(function (result) {
                                                // Handling modal result
                                                var state; // Variable to hold the state
                                                switch (
                                                    result // Switch based on the result
                                                    ) {
                                                    case '0': // Approve action
                                                        state = '0'; // Setting state to 'Approved'
                                                        webix
                                                            .ui({
                                                                // Creating a new window
                                                                view: 'window',
                                                                head: _('Aprobar deposito ') + item.Id, // Window title
                                                                id: 'windowTransfers', // Window ID
                                                                modal: true, // Modal window
                                                                position: 'center', // Center position
                                                                body: {
                                                                    // Window body
                                                                    view: 'form',
                                                                    id: 'windowTransfersForm', // Form ID
                                                                    elements: [
                                                                        // Form elements
                                                                        {
                                                                            view: 'text',
                                                                            label: _('Referencia'), // Label for the input
                                                                            name: 'reference', // Input name
                                                                            id: 'reference', // Input ID
                                                                        },
                                                                        {
                                                                            cols: [
                                                                                // Button layout
                                                                                {
                                                                                    view: 'button',
                                                                                    value: _('Aprobar'), // Button label
                                                                                    id: 'ApproveButton', // Button ID
                                                                                    click: function (elementId, event) {
                                                                                        // Click handler
                                                                                        var values =
                                                                                            $$(
                                                                                                'windowTransfersForm',
                                                                                            ).getValues(); // Getting form values
                                                                                        var tthis = this; // Reference to the current context
                                                                                        $$('ApproveButton').disable(); // Disabling the button
                                                                                        webix
                                                                                            .ajax() // Making an AJAX request
                                                                                            .headers({
                                                                                                'Content-type':
                                                                                                    'application/json', // Setting content type
                                                                                            })
                                                                                            .post(
                                                                                                devConfig.geturlApi() +
                                                                                                'Financial/DepositRequests',
                                                                                                '{ "Id":' +
                                                                                                item.Id +
                                                                                                ', "State":"' +
                                                                                                state +
                                                                                                '","Reference":"' +
                                                                                                values.reference +
                                                                                                '"}', // Request body
                                                                                                {
                                                                                                    error: function (
                                                                                                        text,
                                                                                                        data,
                                                                                                        XmlHttpRequest,
                                                                                                    ) {
                                                                                                        // Error handler
                                                                                                        webix.message(
                                                                                                            _(
                                                                                                                'Error! ',
                                                                                                            ),
                                                                                                        ); // Displaying error message
                                                                                                    },
                                                                                                    success: function (
                                                                                                        text,
                                                                                                        data,
                                                                                                        XmlHttpRequest,
                                                                                                    ) {
                                                                                                        // Success handler
                                                                                                        var data =
                                                                                                            JSON.parse(
                                                                                                                text,
                                                                                                            ); // Parsing response
                                                                                                        if (
                                                                                                            data.HasError
                                                                                                        ) {
                                                                                                            // Checking for errors
                                                                                                            if (
                                                                                                                data.CodeError !=
                                                                                                                110012
                                                                                                            ) {
                                                                                                                webix.message(
                                                                                                                    'No se proceso la solicitud. Comunicarse con soporte. ',
                                                                                                                ); // Displaying error message
                                                                                                            }
                                                                                                            tthis
                                                                                                                .getTopParentView()
                                                                                                                .hide(); // Hiding the modal
                                                                                                        } else {
                                                                                                            webix.message(
                                                                                                                _(
                                                                                                                    'Se ha realizado la transferencia satisfactoriamente. ',
                                                                                                                ),
                                                                                                            ); // Displaying success message
                                                                                                            tthis
                                                                                                                .getTopParentView()
                                                                                                                .hide(); // Hiding the modal
                                                                                                        }
                                                                                                    },
                                                                                                },
                                                                                            );
                                                                                    },
                                                                                },
                                                                                {
                                                                                    view: 'button',
                                                                                    value: _('Cancelar'), // Button label
                                                                                    click: function (elementId, event) {
                                                                                        // Click handler
                                                                                        this.getTopParentView().hide(); // Hiding the modal
                                                                                    },
                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                                move: true, // Allowing window movement
                                                            })
                                                            .show(); // Showing the window
                                                        break;
                                                    case '1': // Cancel action
                                                        state = '1'; // Setting state to 'Approved'
                                                        var tthis = this; // Reference to the current context
                                                        webix
                                                            .ajax() // Making an AJAX request
                                                            .headers({
                                                                'Content-type': 'application/json', // Setting content type
                                                            })
                                                            .post(
                                                                devConfig.geturlApi() + 'Financial/DepositRequests',
                                                                '{ "Id":' + item.Id + ', "State":"' + state + '"}', // Request body
                                                                {
                                                                    error: function (text, data, XmlHttpRequest) {
                                                                        // Error handler
                                                                        webix.message('Error! '); // Displaying error message
                                                                    },
                                                                    success: function (text, data, XmlHttpRequest) {
                                                                        // Success handler
                                                                        var data = JSON.parse(text); // Parsing response
                                                                        if (data.HasError) {
                                                                            // Checking for errors
                                                                            if (data.CodeError != 110012) {
                                                                                webix.message(
                                                                                    'No se proceso la solicitud. Comunicarse con soporte. ',
                                                                                ); // Displaying error message
                                                                            }
                                                                            tthis.getTopParentView().hide(); // Hiding the modal
                                                                        } else {
                                                                            webix.message(
                                                                                'Se ha se procesado la solicitud satisfactoriamente. ',
                                                                            ); // Displaying success message
                                                                            tthis.getTopParentView().hide(); // Hiding the modal
                                                                        }
                                                                    },
                                                                },
                                                            );
                                                        break;
                                                    case '2': // Cancel action
                                                        this.getTopParentView().hide(); // Hiding the modal
                                                        break;
                                                }
                                            });
                                    }
                                },
                                'icon-file-text': function (e, id) {
                                    // Handler for view payment receipt icon click

                                    const item = this.getItem(id.row); // Getting the clicked row item
                                    const depositId = item.Id; // Extracting deposit ID
                                    const typePayment = item.PaymentDocType; // Extracting payment document type

                                    // Creating the receipt window if it does not exist
                                    if (!$$("receiptWindow")) {
                                        webix.ui({
                                            view: "window",
                                            id: "receiptWindow",
                                            width: 700,
                                            height: 500,
                                            position: "center",
                                            modal: true,
                                            head: {
                                                cols: [
                                                    { template: "Comprobante de pago", type: "header", borderless: true }, // Window title
                                                    {
                                                        view: "icon",
                                                        id: "downloadBtn",
                                                        icon: "wxi-download",
                                                        tooltip: "Descargar",
                                                        hidden: true, // Hidden by default
                                                        click: function () {
                                                            // Download button click handler
                                                            const win = $$("receiptWindow"); // Getting window instance
                                                            const url = win.downloadUrl; // Retrieving stored file URL

                                                            if (!url) return; // Exit if no URL available

                                                            // Creating a temporary link to trigger download
                                                            const link = document.createElement("a");
                                                            link.href = url;
                                                            link.download = "comprobante_" + Date.now() + ".png"; // Dynamic file name
                                                            document.body.appendChild(link);
                                                            link.click();
                                                            document.body.removeChild(link);
                                                        }
                                                    },
                                                    {
                                                        view: "icon",
                                                        icon: "wxi-close",
                                                        click: function () {
                                                            // Close button handler
                                                            $$("receiptWindow").hide();
                                                        }
                                                    }
                                                ]
                                            },
                                            body: {
                                                rows: [
                                                    {
                                                        view: "template",
                                                        id: "receiptContent",
                                                        template: "Cargando...", // Initial loading state
                                                        borderless: true
                                                    }
                                                ]
                                            },
                                            on: {
                                                onHide: function () {
                                                    // Cleanup when window is closed
                                                    $$("receiptContent").setHTML(""); // Clear content
                                                    this.downloadUrl = null; // Reset stored URL
                                                    $$("downloadBtn").hide(); // Hide download button
                                                }
                                            }
                                        });
                                    }

                                    $$("receiptWindow").show(); // Displaying the window

                                    // Request to retrieve payment document
                                    webix.ajax()
                                        .headers({
                                            "Content-type": "application/json"
                                        })
                                        .post(
                                            devConfig.geturlApi() + "Financial/GetPaymentDoc",
                                            JSON.stringify({
                                                Id: depositId, // Sending deposit ID
                                                Type: typePayment // Sending document type
                                            }),
                                            {
                                                error: function () {
                                                    // Error handler for request
                                                    webix.message("Error al obtener el comprobante");
                                                },
                                                success: function (text) {
                                                    // Success handler for request

                                                    const json = JSON.parse(text); // Parsing response

                                                    if (json.HasError) {
                                                        // Handling backend error
                                                        webix.message("No se pudo obtener el comprobante");
                                                        $$("receiptWindow").hide();
                                                        return;
                                                    }

                                                    const url = json.data.Url; // Extracting document URL
                                                    let html = ""; // Variable to hold rendered HTML

                                                    const win = $$("receiptWindow");
                                                    win.downloadUrl = url; // Storing URL for download usage

                                                    if (typePayment == 0) {
                                                        // If document is an image
                                                        html = "<img src='" + url + "' style='max-width:100%;max-height:100%;display:block;margin:auto;' />";
                                                        $$("downloadBtn").show(); // Show download button
                                                    } else {
                                                        // If document is PDF or other type
                                                        html = "<iframe src='" + url + "' style='width:100%;height:100%;border:0'></iframe>";
                                                        $$("downloadBtn").hide(); // Hide download button
                                                    }

                                                    $$("receiptContent").setHTML(html); // Rendering content in template
                                                }
                                            }
                                        );
                                }
                            },
                            tooltip: true, // Enabling tooltips
                            footer: true, // Enabling footer
                            math: true, // Enabling math calculations
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }
    init(grid) {
        // Method to initialize the view
        grid = $$('datatable'); // Getting the datatable instance
        const _ = this.app.getService('locale')._; // Localization service for translations
        var url = devConfig.geturlApi() + 'es/Financial/GetDepositRequests'; // API URL for fetching deposit requests
        var filter = ''; // Variable to hold filter string
        this.on(this.app, 'depositReport:filter', (filterData) => {
            // Event listener for filter updates
            var object = Object.entries(filterData); // Converting filter data to entries
            var string1 = ''; // Variable to hold query string
            var providergroup = 0; // Variable for provider group
            for (var i = 0; i < object.length; i++) {
                // Iterating through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Checking for non-object and non-empty values
                    if (object[i][0] == 'Datepicker') {
                        // Checking for datepicker filter
                        var date = object[i][1].split(' - '); // Splitting date range
                        console.log(date); // Logging date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Adding dateFrom to query string
                        string1 = string1 + '&dateTo=' + date[1]; // Adding dateTo to query string
                    } else {
                        if (object[i][0] != 'Date') {
                            // Checking for non-date filters
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Adding filter to query string
                        } else {
                            if (object[i][0] == 'Date') {
                                // Checking for date filter
                                var date = object[i][1].replace(' 00:00:00', ''); // Formatting date
                                string1 = string1 + '&dateFrom=' + date; // Adding dateFrom to query string
                                string1 = string1 + '&dateTo=' + date; // Adding dateTo to query string
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Checking for object filters
                        var object2 = Object.entries(object[i][1]); // Converting object filter to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterating through object entries
                            if (object2[j][1] !== null) {
                                // Checking for non-null values
                                if (object2[j][0] === 'start') {
                                    // Checking for start date
                                    var d = new Date(object2[j][1]); // Creating date object
                                    var dateFrom =
                                        'ModifiedLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Formatting date
                                    string1 = string1 + '&' + dateFrom; // Adding dateFrom to query string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Checking for end date
                                        var d = new Date(object2[j][1]); // Creating date object
                                        var dateTo =
                                            'ModifiedLocalEnd=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Formatting date
                                        string1 = string1 + '&' + dateTo; // Adding dateTo to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clearing the datatable
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Loading data with filters
            filter = string1; // Updating filter variable
            $$('filterPopup').hide(); // Hiding filter popup
        });
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event listener for sorting
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Loading data with sorting
            );
        });
        this.on(this.app, 'player:select', (Id) => {
            // Event listener for player selection
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Loading data based on selected player
            );
        });
    }
}

// FILE DOCUMENTED
